import FeaturesListBlock from './FeaturesListBlock';

export default FeaturesListBlock;
